// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__BR-6W","title":"Info_title__1g6YL","selects":"Info_selects__3s3DO","requiredAsterisk":"Info_requiredAsterisk__EzILA"};